export const REDUCER_NAME = "nationalTeamCoaches";
export const SET_ERROR = `${REDUCER_NAME}/SET_ERROR`;
export const SET_NATIONALTEAM_COACHES = `${REDUCER_NAME}/SET_NATIONALTEAM_COACHES`;
export const RESET_NATIONALTEAM_COACHES = `${REDUCER_NAME}/RESET_NATIONALTEAM_COACHES`;
